import { ResourceDTO, Timezone } from '@/lib/types/resource'
import api from './axios'

const baseUrl = '/rest/v1/resources'

export async function getResources(params?: PagedRequestParams): Promise<PagedResult<ResourceDTO>> {
  const body = params ? {
    params: {
      offset: params.offset,
      limit: params.limit,
      sortField: params.sortField,
      sortOrder: params.sortOrder,
      ...params.filters
    }
  } : {}

  const res = await api.get(baseUrl, body)

  return res.data
}

export async function findResources(filters: { ids?: string[], resource_type_ids?: string[] }): Promise<PagedResult<ResourceDTO>> {
  const res = await api.post(`${baseUrl}/find`, filters)
  return res.data
}

export async function createResource(data: ResourceDTO): Promise<ErrorMessage | ResourceDTO> {
  const { id, ...payload } = data
  const res = await api.post(baseUrl, payload)
  return res.data
}

export async function updateResource(data: ResourceDTO): Promise<ErrorMessage | ResourceDTO> {
  const { id, ...payload } = data
  const res = await api.put(`${baseUrl}/${id}`, payload)
  return res.data
}

export async function deleteResource(id: string): Promise<ErrorMessage | void> {
  await api.delete(`${baseUrl}/${id}`)
}

export async function getTimezones(): Promise<Timezone[]> {
  const res = await api.get(`${baseUrl}/timezones`)
  return res.data
}